import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faAddressCard,
  faArrowLeft,
  faArrowRight,
  faArrowsRotate,
  faArrowUpRightFromSquare,
  faBagShopping,
  faBan,
  faBars,
  faBook,
  faBell,
  faBoxOpen,
  faBuilding,
  faBullhorn,
  faCalculator,
  faCalendarCheck,
  faCar,
  faCheck,
  faChartLine,
  faCheckDouble,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCircle,
  faCircleCheck,
  faCircleDot,
  faCircleExclamation,
  faCircleInfo,
  faCircleQuestion,
  faClock,
  faCode,
  faEllipsis,
  faComment,
  faCopy,
  faDownLeftAndUpRightToCenter,
  faDownload,
  faEyeSlash,
  faFileArrowDown,
  faFileCirclePlus,
  faFileLines,
  faFilter,
  faGear,
  faHandPointer,
  faHandshake,
  faHashtag,
  faImage,
  faLandmark,
  faLink,
  faLock,
  faMagnifyingGlass,
  faMapLocationDot,
  faMicrophone,
  faMinus,
  faMoneyBillWave,
  faNoteSticky,
  faPaperclip,
  faPaperPlane,
  faPen,
  faPercent,
  faPhone,
  faPlus,
  faPowerOff,
  faQrcode,
  faRectangleList,
  faReply,
  faRightToBracket,
  faRobot,
  faRotateLeft,
  faSearch,
  faShare,
  faShareNodes,
  faShieldHalved,
  faSquare,
  faStore,
  faSquareCheck,
  faStop,
  faSliders,
  faTimes,
  faTags,
  faToggleOn,
  faToggleOff,
  faTrash,
  faTriangleExclamation,
  faUpRightAndDownLeftFromCenter,
  faUser,
  faUserGear,
  faUsers,
  faVideo,
  faWrench,
  faWindowMinimize,
} from '@fortawesome/free-solid-svg-icons';

import {
  faCircle as faCircleRegular,
  faCopy as faCopyRegular,
  faSquare as faSquareRegular,
  faWindowMaximize,
} from '@fortawesome/free-regular-svg-icons';

import {
  faWhatsapp as faWhatsApp,
  faFacebookF as faFacebook,
  faFacebookMessenger,
  faInstagram,
  faTiktok as faTikTok,
} from '@fortawesome/free-brands-svg-icons';

library.add(faAddressCard);
library.add(faArrowLeft);
library.add(faArrowRight);
library.add(faArrowsRotate);
library.add(faArrowUpRightFromSquare);
library.add(faBagShopping);
library.add(faBan);
library.add(faBars);
library.add(faBook);
library.add(faBell);
library.add(faBoxOpen);
library.add(faBuilding);
library.add(faBullhorn);
library.add(faCalculator);
library.add(faCalendarCheck);
library.add(faCar);
library.add(faCheck);
library.add(faChartLine);
library.add(faCheckDouble);
library.add(faChevronDown);
library.add(faChevronLeft);
library.add(faChevronRight);
library.add(faChevronUp);
library.add(faCircle);
library.add(faCircleRegular);
library.add(faCircleCheck);
library.add(faCircleDot);
library.add(faCircleExclamation);
library.add(faCircleInfo);
library.add(faCircleQuestion);
library.add(faClock);
library.add(faCode);
library.add(faEllipsis);
library.add(faComment);
library.add(faCopy);
library.add(faCopyRegular);
library.add(faDownLeftAndUpRightToCenter);
library.add(faDownload);
library.add(faEyeSlash);
library.add(faFileArrowDown);
library.add(faFileCirclePlus);
library.add(faFileLines);
library.add(faFilter);
library.add(faGear);
library.add(faHandPointer);
library.add(faHandshake);
library.add(faHashtag);
library.add(faImage);
library.add(faLandmark);
library.add(faLink);
library.add(faLock);
library.add(faMagnifyingGlass);
library.add(faMapLocationDot);
library.add(faMicrophone);
library.add(faMinus);
library.add(faMoneyBillWave);
library.add(faNoteSticky);
library.add(faPaperclip);
library.add(faPaperPlane);
library.add(faPen);
library.add(faPercent);
library.add(faPhone);
library.add(faPlus);
library.add(faPowerOff);
library.add(faQrcode);
library.add(faRectangleList);
library.add(faReply);
library.add(faRightToBracket);
library.add(faRobot);
library.add(faRotateLeft);
library.add(faSearch);
library.add(faShare);
library.add(faShareNodes);
library.add(faShieldHalved);
library.add(faSquare);
library.add(faStore);
library.add(faSquareCheck);
library.add(faStop);
library.add(faSquareRegular);
library.add(faSliders);
library.add(faTimes);
library.add(faTags);
library.add(faToggleOn);
library.add(faToggleOff);
library.add(faTrash);
library.add(faTriangleExclamation);
library.add(faUpRightAndDownLeftFromCenter);
library.add(faUser);
library.add(faUserGear);
library.add(faUsers);
library.add(faVideo);
library.add(faWrench);
library.add(faWindowMaximize);
library.add(faWindowMinimize);

library.add(faFacebook);
library.add(faFacebookMessenger);
library.add(faInstagram);
library.add(faTikTok);
library.add(faWhatsApp);
